import { IconCirclePlus, IconEdit, IconRefresh, IconToggleLeft, IconToggleRight, IconUserPlus, IconUserScan } from '@tabler/icons-react'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
import { getApi } from '../../api/call.api'
import { urlApi } from '../../api/url.api'
import IconButton from '../../components/Buttons/IconButton'
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal'
import TableComponent from '../../components/DataTable/TableComponent'
import DateRange from '../../components/DateRange/DateRange'
import DropDown from '../../components/DropDown/DropDown'
import Pagination from '../../components/Pagination/Pagination'
import SearchComponent from '../../components/Search/SearchComponent'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller'
import { dateTimeConverter } from '../../utils/dateTimeConverter'
import AddInfluencerModal from './Components/AddInfluencerModal'
import AgentListOfInfluencerModal from './Components/AgentListOfInfluencerModal'
import LinkAgentToInfluencerModal from './Components/LinkAgentToInfluencerModal'
import UpdateInfluencerModal from './Components/UpdateInfluencerModal'
import { accessCheck } from '../../utils/accessCheck'
import { accessKeys } from '../../statics/accessKeys'

const Influencer = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchData, setSearchData] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null);
    const [platformFilter, setPlatformFilter] = useState(null);
    const [genreFilter, setGenreFilter] = useState(null);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const statusList = [{
        id: null,
        name: "All"
    }, {
        id: 1,
        name: "Active"
    }, {
        id: 2,
        name: "Inactive"
    }];

    const platformList = [{
        id: null,
        name: "All"
    }, {
        id: 1,
        name: 'YouTube'
    }, {
        id: 2,
        name: 'Facebook'
    }, {
        id: 3,
        name: 'Instagram'
    }, {
        id: 4,
        name: 'Threads'
    }, {
        id: 5,
        name: 'X'
    }, {
        id: 6,
        name: 'Twitter'
    }, {
        id: 7,
        name: 'LinkedIn'
    }, {
        id: 8,
        name: 'TikTok'
    }, {
        id: 9,
        name: 'Pinterest'
    }, {
        id: 10,
        name: 'Reddit'
    }, {
        id: 11,
        name: 'Snapchat'
    }, {
        id: 12,
        name: 'WhatsApp'
    }, {
        id: 13,
        name: 'Discord'
    }, {
        id: 14,
        name: "Others"
    }];

    const genreList = [{
        id: null,
        name: "All"
    }, {
        id: 1,
        name: "Fashion"
    }, {
        id: 2,
        name: "Beauty"
    }, {
        id: 3,
        name: "Fitness"
    }, {
        id: 4,
        name: "Gaming"
    }, {
        id: 5,
        name: "Tech"
    }, {
        id: 6,
        name: "Travel"
    }, {
        id: 7,
        name: "Food"
    }, {
        id: 8,
        name: "Lifestyle"
    }, {
        id: 9,
        name: "Business"
    }, {
        id: 10,
        name: "Finance"
    }, {
        id: 11,
        name: "Education"
    }, {
        id: 12,
        name: "Motivation"
    }, {
        id: 13,
        name: "Entertainment"
    }]

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    async function getAllInfluencers() {
        loadingShow();
        let statusFilterLocal = statusList?.find(item => item?.name == statusFilter);
        let platformFilterLocal = platformList?.find(item => item?.name == platformFilter);
        let genreFilterLocal = genreList?.find(item => item?.name == genreFilter);
        let url = `${urlApi.getInfluencerList}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += "&search=" + searchData
        }
        if (statusFilterLocal?.id) {
            url += "&filterByStatus=" + statusFilterLocal?.id
        }
        if (platformFilterLocal?.id) {
            url += "&filterByPlatform=" + platformFilterLocal?.id
        }
        if (genreFilterLocal?.id) {
            url += "&filterByGenre=" + genreFilterLocal?.id
        }
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys.viewInfluencerDetails)) {
            getAllInfluencers();
        }
    }, [activePage, perPage, statusFilter, searchData, platformFilter, genreFilter]);

    function resetAll() {
        setActivePage(1);
        setPerPage(10);
        setSearchData('');
        setStatusFilter(null);
        setPlatformFilter(null);
        setGenreFilter(null);
        document.getElementById("agent-table-search").value = ""
    }

    function onStatusFilterChange(filter) {
        setStatusFilter(filter);
        setActivePage(1);
    }

    function onPlatformFilterChange(filter) {
        setPlatformFilter(filter);
        setActivePage(1);
    }

    function onGenreFilterChange(filter) {
        setGenreFilter(filter);
        setActivePage(1);
    }

    const updateStatus = async (rowData) => {
        let status = rowData.status == 1 ? 2 : 1

        let resp = await getApi(`${urlApi.updateInfluencerStatus}${rowData?._id}/${status}`);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getAllInfluencers();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No.", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Channel", center: "true", grow: 1.4, selector: (row) => row?.category, cell: (row) => (
                <Link to={"/influencer/" + row?._id}>
                    <div className="flex items-center gap-2">
                        <img src={row?.channelLogo || "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg"} className='w-10 aspect-square rounded-full my-1 object-cover' alt="" />
                        <p className="mb-0">{row?.channelName}</p>
                    </div>
                </Link>
            )
        }, {
            name: "Platform", center: "true", grow: 0.1, selector: (row) => row?.platform, cell: (row) => (
                <p className="mb-0"> {row?.platform || "--"} </p>
            )
        }, {
            name: "Genre", center: "true", grow: 0.1, selector: (row) => row?.genre, cell: (row) => (
                <p className="mb-0"> {row?.genre || "--"} </p>
            )
        }, {
            name: "Contacts", center: "true", selector: (row) => row?.title, grow: 0.9, cell: (row) => (
                <div>
                    <p className="mb-1">{row?.phone || "--"}</p>
                    <p className="mb-0">{row?.email || "--"}</p>
                </div>
            )
        }, {
            name: "Created", center: "true", selector: (row) => row?.title, grow: 0.5, cell: (row) => (
                <p className="mb-0"> {dateTimeConverter(row?.createdAt)}</p>
            )
        }, {
            name: "Agents", center: "true", selector: (row) => row?.title, width: "70px", cell: (row) => (
                <AgentListOfInfluencerModal buttonComponent={<IconButton icon={<IconUserScan />} />} influencerData={row} />
            )
        }, {
            name: "Add Agent", center: "true", selector: (row) => row?.link, width: "70px", omit: !accessCheck(accessKeys.linkExistingAgent), grow: 0.1, cell: (row) => (
                <LinkAgentToInfluencerModal buttonComponent={<button title='Add Agent'> <IconUserPlus size={20} color='#15BC00' /> </button>} influencerData={row} />
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.link, width: "70px", grow: 0.1, cell: (row) => (
                <div>
                    {accessCheck(accessKeys.updateInfluencerStatus) ? <ConfirmationModal buttonComponent={<IconButton icon={row?.status == 1 ? <IconToggleRight color='green' /> : <IconToggleLeft color='red' />} />} confirmationText={`Are you sure want to ${row?.status == 1 ? 'inactive' : 'active'} ${row?.name}`} onConfirm={() => updateStatus(row)} /> : <IconButton icon={row?.status == 1 ? <IconToggleRight color='green' /> : <IconToggleLeft color='red' />} />}
                </div>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.link, width: "70px", grow: 0.1, omit: !accessCheck(accessKeys.createAndEditInfluencer), cell: (row) => (
                <UpdateInfluencerModal buttonComponent={<button title='Edit Influencer Details'> <IconEdit size={20} color='#9747FF' /> </button>} callback={() => getAllInfluencers()} influencerData={row} key={row?._id} />

            )
        }
    ];

    return (
        <Layout>
            <div className='flex mb-3 gap-3 flex-wrap justify-between items-center'>
                <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Influencers</p>
                <div className='flex gap-2'>
                    {accessCheck(accessKeys.createAndEditInfluencer) && <AddInfluencerModal buttonComponent={<IconButton icon={<IconCirclePlus size={20} />} text={"Add Influencer"} />} callback={() => getAllInfluencers()} />}
                </div>
            </div>

            <div className="flex gap-3 flex-wrap mb-3">
                <SearchComponent onClear={() => { document.getElementById("agent-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("agent-table-search")?.value); setActivePage(1) }} inputId='agent-table-search' placeholder={"Influencer Name / Mobile / Email"} />
                <DateRange />
                <div className="ms-auto flex items-center gap-2">
                    <DropDown title={"Platform"} list={platformList?.map(item => item?.name)} defaultValue={platformFilter} onSelect={(filter) => onPlatformFilterChange(filter)} />
                    <DropDown title={"Genre"} list={genreList?.map(item => item?.name)} defaultValue={genreFilter} onSelect={(filter) => onGenreFilterChange(filter)} />
                    <DropDown title={"Status"} list={statusList?.map(item => item?.name)} defaultValue={statusFilter} onSelect={(filter) => onStatusFilterChange(filter)} />
                    <button onClick={() => resetAll()}> <IconRefresh /> </button>
                </div>
            </div>

            <div className="rounded-xl">
                <TableComponent
                    columns={columns}
                    data={tableData.data}
                    totalRows={tableData.totalCount}
                    isHeader={true}
                    isPagination={false}
                    paginationPerPage={perPage}
                    handlePageChange={(e) => handlePageChange(e)}
                    handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
            </div>
        </Layout>
    )
}

export default Influencer